import scssVariables from 'styles/sass-variables.module.scss';

export const dividerOverrides = {
  root: () => ({
    margin: '16px 0px',
    color: scssVariables.border,
    '& .MuiDivider-wrapper': {
      padding: '0px 24px',
      color: scssVariables.text_secondary,
    },
  }),
};
